import config from 'config'
import React, { useEffect, useState } from 'react';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu'
import stock from "LIBRARY/CommonResources/images/stock.png"
import bookStock from "LIBRARY/CommonResources/images/bookStock.png"
import ebook from "LIBRARY/CommonResources/images/e-book.png"
import newspaper from "LIBRARY/CommonResources/images/newspaper.png"
import stopped from "LIBRARY/CommonResources/images/stopped.png"
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import tick from "LIBRARY/CommonResources/images/tick.png"
import link from "LIBRARY/CommonResources/images/link.png"
import pdfImg from "LIBRARY/CommonResources/images/pdfImg.png"
import sound from "LIBRARY/CommonResources/images/sound.png"
import video from "LIBRARY/CommonResources/images/video.png"
import qrcode from "LIBRARY/CommonResources/images/qrcode.png"
import defaultUser from "LIBRARY/CommonResources/images/defaultUser.png"
import Chart from "react-apexcharts";
import QRCode from "react-qr-code";
import LibraryApiCall from 'LibraryApiCall';
import Barcode from "react-barcode";
import './dashboard.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';

export const Dashboard = () => {

  //required states 
  const [resourceCount, setResourceCount] = useState('');
  const [eResourceCount, setEResourceCount] = useState('');
  const [periodicalsCount, setPeriodicalsCount] = useState('');
  const [availableCount, setAvailableCount] = useState('');
  const [missingCount, setMissingCount] = useState('');
  const [donorCount, setDonorCount] = useState('');
  const [categoryCount, setCategoryCount] = useState('');
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [pRCount, setPRCount] = useState('');
  const [requisitionCount, setRequisitionCount] = useState('');
  const [approvedRequisitionCount, setApprovedRequisitionCount] = useState('');
  const [pendingRequisitionCount, setPendingRequisitionCount] = useState('');
  const [declinedRequisitionCount, setDeclinedRequisitionCount] = useState('');
  const [issuedCount, setIssuedCount] = useState('');
  const [returnedCount, setReturnedCount] = useState('');
  const [issueReturnData, setIssueReturnData] = useState({});
  const [loadingIssueList, setLoadingIssueList] = useState(false);
  const [eResourceData, setEResourceData] = useState({});
  const [loadingEResourceList, setLoadingEResourceList] = useState(false);
  const [totalIssuedResourceCount, setTotalIssuedResourceCount] = useState('');
  const [opacLink, setOpacLink] = useState(config.RootUrl + '/public/library/#/' + config.instituteUrl);
  const [showInstituteWiseOPAC, setShowInstituteWiseOPAC] = useState(false)

  const AdminAccessReducer = useSelector((state) => state.RouteMenuReducer);

  useEffect(() => {
    if (AdminAccessReducer?.iidArray?.iidArray?.length > 0) {
      apiCallToDashboardCount()
      apiToGetAllIssuedResourceList()
      apiToGetLibraryEResources()
    }

    if (AdminAccessReducer?.multipleInstituteDetails?.multipleInstituteDetails?.length > 0) {
      setOpacLink(config.RootUrl + '/public/library/#/' + Object.values(AdminAccessReducer?.multipleInstituteDetails?.multipleInstituteDetails)[0].institute_url)
    }
  }, [AdminAccessReducer?.iidArray]);


  // API CALL TO GET ALL DATA COUNTS FOR DASHBOARD
  const apiCallToDashboardCount = async (pageNumber) => {
    setLoadingStatus(true);

    let requestData = {
      "iid": config.institute_id,
      "facultyId": config.faculty_id,
      "role": "teaching",
      "isAdmin": 'true',
      "iidArray": AdminAccessReducer.iidArray.iidArray,
    };
    let jsonResponse = await LibraryApiCall.makeApiCall(
      'getLibraryDashboardCount',
      requestData,
      '/api/library/instructor.php'
    );
    if (jsonResponse.expired) {
      setTimeout(() => {
        apiCallToDashboardCount();
      }, 1000);
    } else {
      if (jsonResponse.success) {
        let apiResult = jsonResponse.APIResult;

        setResourceCount(apiResult.resources_count)
        setEResourceCount(apiResult.e_resource_count);
        setPeriodicalsCount(apiResult.periodicals_count);
        setAvailableCount(apiResult.available_resources_count);
        setMissingCount(apiResult.other_resources_count);
        setCategoryCount(apiResult.resource_category_count);
        setRequisitionCount(apiResult.resource_requisition_count);
        setDonorCount(apiResult.donors_count);
        setPRCount(apiResult.PR_count);
        setApprovedRequisitionCount(apiResult.approved_requisition);
        setPendingRequisitionCount(apiResult.pending_requisition);
        setDeclinedRequisitionCount(apiResult.declined_requisition);
        setTotalIssuedResourceCount(apiResult.total_issued_resource_count)
        setLoadingStatus(false);
      }
    }
  }

  // API CALL TO GET LIST OF ISSUED RESOURCES
  const apiToGetAllIssuedResourceList = async (pageNumber) => {
    setLoadingIssueList(true);

    let requestData = {
      "iid": config.institute_id,
      "pageIndex": 1,
      "limitPerPage": 10,
      "iidArray": AdminAccessReducer.iidArray.iidArray,
    };
    let jsonResponse = await LibraryApiCall.makeApiCall(
      'GetAllIssuedResourceList',
      requestData,
      '/api/library/instructor.php'
    );
    if (jsonResponse.expired) {
      setTimeout(() => {
        apiToGetAllIssuedResourceList();
      }, 1000);
    } else {
      if (jsonResponse.success) {
        let apiResult = jsonResponse.APIResult;

        setIssuedCount(apiResult.IssuedCount);
        setReturnedCount(apiResult.ReturnedCount);
        setIssueReturnData(apiResult.data);
        setLoadingIssueList(false);
      }
    }
  }

  // API CALL TO GET LIST OFR E-RESOURCES 
  const apiToGetLibraryEResources = async (pageNumber) => {
    setLoadingEResourceList(true);

    let requestData = {
      "instituteId": config.institute_id,
      "pageIndex": 1,
      "limit": 5,
      "iidArray": AdminAccessReducer.iidArray.iidArray,
    };
    let jsonResponse = await LibraryApiCall.makeApiCall(
      'library_getEResources',
      requestData,
      '/api/library/library.php'
    );
    if (jsonResponse.expired) {
      setTimeout(() => {
        apiToGetLibraryEResources();
      }, 1000);
    } else {
      if (jsonResponse.success) {
        let apiResult = jsonResponse.APIResult;

        setEResourceData(apiResult.data);
        setLoadingEResourceList(false);
      }
    }
  }

  // DATA GOT FOR DONUT FOR REQUISITION
  const series = [approvedRequisitionCount, pendingRequisitionCount, declinedRequisitionCount];
  const labels = ['Approved', 'Pending', 'Declined'];

  const options = {
    labels: labels,
    colors: ['#0465AC', '#FFA129', '#FF7E7E']
  };

  const returnMultipleOpacLink = () => {
    return (
      <div id="addAccessSideMenu" style={{ display: showInstituteWiseOPAC ? 'flex' : 'none' }}>
        <div id="addMemberDataContainer">
          <div id="addAccessHeader" className="row">
            <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="#000" onClick={() => setShowInstituteWiseOPAC(false)} style={{ cursor: "pointer" }} />
            <h5 style={{ paddingLeft: '30%' }} className="col-11">Institute Wise OPAC Access Link</h5>
          </div>

          <div className="table-responsive p-3">
            <table className="table table-bordered  vm_libraryReport_table" id="resourceList">
              <thead style={{ position: 'sticky' }}>
                {/* Column headers */}
                <tr>
                  <th className='vm_custom_body4' style={{ padding: '5px 5px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Institute</th>
                  <th className='vm_custom_body4' style={{ padding: '5px 5px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Access OPAC URL</th>
                  <th className='vm_custom_body4' style={{ padding: '5px 5px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>QR Code</th>
                </tr>
              </thead>

              <tbody>
                {
                  Object.keys(AdminAccessReducer?.multipleInstituteDetails?.multipleInstituteDetails).length > 0 &&
                  Object.keys(AdminAccessReducer?.multipleInstituteDetails?.multipleInstituteDetails).map((items, index) => {
                    let instituteDetails = AdminAccessReducer?.multipleInstituteDetails?.multipleInstituteDetails[items];
                    let opacLinkData = config.RootUrl + '/public/library/#/' + instituteDetails.institute_url; // dynamically set here
                    return (

                      <tr key={index}>
                        <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{instituteDetails.institute_short_code}</p>}</td>
                        <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<a href={opacLinkData} target="_blank" className="headings ui-link-hover" style={{ fontWeight: 'bold', color: '#007bff', cursor: 'pointer' }}><u>Access OPAC</u></a>}</td>
                        <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<QRCode
                          value={opacLinkData}
                          size={75}
                        />}</td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <RoutingMenu activeScreen="dashboard" />
      <div className='libraryDashboard-container'>
        {/* <iframe
              src={`${config.RootUrl}/faculty/library/libraryDashboardHTML.php?isIframe=true`}
              className="iframe col-md-12" >
          </iframe> */}

        <div className='dashboard pb-4'>Dashboard</div>
        <div className="col-md-12 pl-0 pr-0 pb-5">
          <div className="row">
            <div className="col-md-8 pr-0 pl-0" >
              <div className="row">
                {/* COUNTS OF ALL TYPES OF RESOURCE DATA */}
                <div class="rectangles" >
                  <div class="col-md-12 d-flex mt-4">
                    <div className="col-md-4 mt-3">
                      <img style={{ maxHeight: "50px", minWidth: "25%", maxWidth: "100%" }} src={bookStock} />
                    </div>
                    <div className="col-md-8">
                      <p className='names'>Resources</p>
                      <p className='mt-4 d-flex justify-content-between'>
                        {loadingStatus ?
                          <div className="counts d-flex justify-content-center align-items-center">
                            0
                          </div>
                          :
                          <span className="counts">{resourceCount}</span>
                        }

                        <span>
                          {/* <FontAwesomeIcon icon={['fas', 'chevron-circle-right']} size="xl" color='#7cabcc' className='rightAngle' onClick={() => window.location.href = config.RootUrl + '/modules/library/#/resource'} /> */}
                          <FontAwesomeIcon icon={['fas', 'chevron-circle-right']} size="xl" color='#7cabcc' className='rightAngle' onClick={() => window.location.href = config.RootUrl + '/modules/library/#/resourceDetails'} />
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="rectangles marginTopForMobView">
                  <div class="col-md-12 d-flex mt-4">
                    <div className="col-md-4 mt-3">
                      <img style={{ maxHeight: "50px", minWidth: "25%", maxWidth: "100%" }} src={ebook} />
                    </div>
                    <div className="col-md-8">
                      <p className='names'>E-Resources</p>
                      <p className='mt-4 d-flex justify-content-between'>
                        {loadingStatus ?
                          <div className="counts d-flex justify-content-center align-items-center">
                            0
                          </div>
                          :
                          <span className="counts">{eResourceCount}</span>
                        }
                        <span>
                          <FontAwesomeIcon icon={['fas', 'chevron-circle-right']} size="xl" color='#7cabcc' className='rightAngle' onClick={() => window.location.href = config.RootUrl + '/modules/library/#/eresources'} />
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="rectangles marginTopForMobView">
                  <div class="col-md-12 d-flex mt-4">
                    <div className="col-md-4 mt-3">
                      <img style={{ maxHeight: "50px", minWidth: "25%", maxWidth: "100%" }} src={newspaper} />
                    </div>
                    <div className="col-md-8">
                      <p className='names'>Periodicals/Journal/Newspaper</p>
                      <p className='mt-3 d-flex justify-content-between'>
                        {loadingStatus ?
                          <div className="counts d-flex justify-content-center align-items-center">
                            0
                          </div>
                          :
                          <span className="counts">{periodicalsCount}</span>
                        }
                        <span>
                          <FontAwesomeIcon icon={['fas', 'chevron-circle-right']} size="xl" color='#7cabcc' className='rightAngle' onClick={() => window.location.href = config.RootUrl + '/modules/library/#/periodicals'} />
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="rectangle marginTopForMobView">
                  <div class="col-md-12 d-flex mt-4">
                    <div className="col-md-6">
                      <p className='headings'>Available Resources &nbsp;&nbsp;
                        <span><img style={{ maxHeight: "11px", minWidth: "10%", maxWidth: "90%" }} src={tick} /></span>
                      </p>
                      {loadingStatus ?
                        <div className="counts mt-3 d-flex justify-content-center align-items-center">
                          0
                        </div>
                        :
                        <p className='mt-4 counts'>{availableCount}</p>
                      }
                    </div>
                    <div className="col-md-6">
                      {/* Missing /Discarded &nbsp; */}
                      <p className='headings'>Not Available&nbsp;
                        <span><img style={{ maxHeight: "11px", minWidth: "10%", maxWidth: "90%" }} src={stopped} /></span>
                      </p>
                      {loadingStatus ?
                        <div className="counts mt-3 d-flex justify-content-center align-items-center">
                          0
                        </div>
                        :
                        <p className='mt-4 counts'>{missingCount}</p>
                      }
                    </div>
                  </div>
                </div>
              </div>
              {/* E-RESOURCES LIST */}
              <div className="eResource-rectangle marginTopForMobView" style={{overflowX:'auto'}}>
                <div className="col-md-12 pt-3">
                  E-Resources
                  <div className='mt-3 d-flex justify-content-between eResourceWidth'>
                    {loadingEResourceList ?
                      <div className=" d-flex justify-content-center align-items-center">
                        <ButtonLoader />
                      </div>
                      :

                      Object.keys(eResourceData).length > 0 &&
                      Object.keys(eResourceData).reverse().map((items, index) => {
                        const eResources = eResourceData[items];
                        let resourceImg;

                        switch (eResources.resourceType) {
                          case "PDF":
                            resourceImg = pdfImg;
                            break;
                          case "URL":
                            resourceImg = link;
                            break;
                          case "Audio":
                            resourceImg = sound;
                            break;
                          default:
                            resourceImg = video;
                        }

                        return (
                          <>
                            <div key={index} className='eResources ml-3'>
                              <div className='d-flex flex-column align-items-center '>
                                <div className="image-container">
                                  {eResources.resourceThumbnail != '' && eResources.resourceThumbnail != undefined ?
                                    (
                                      <div className='d-flex flex-column align-items-center'>
                                        <img
                                          className="eResource-images"
                                          resizeMode='contain'
                                          src={eResources.resourceThumbnail}
                                        />
                                      </div>
                                    ) :
                                    (
                                      eResources.resourceType === 'URL' ?
                                        (<div className='d-flex flex-column align-items-center pt-4 '>
                                          <img
                                            style={{ height: "30%", width: "40%" }}
                                            resizeMode='contain'
                                            src={resourceImg}
                                          />
                                        </div>)
                                        :
                                        (<div className='d-flex flex-column align-items-center pt-4 '>
                                          <img
                                            style={{ height: "30%", width: "35%" }}
                                            resizeMode='contain'
                                            src={resourceImg}
                                          />
                                        </div>)
                                    )
                                  }
                                </div>
                              </div>
                              <div className='mt-3'>
                                <p className='headings' style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={eResources.resourceTitle}>{eResources.resourceTitle.length > 30 ? eResources.resourceTitle.substring(0, 30) + '...' : eResources.resourceTitle} | {eResources.eResourceInstituteName}</p>
                                <p style={{ color: '#555555', fontSize: '12px', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} >- By {eResources.resourceAuthor.length > 30 ? eResources.resourceAuthor.substring(0, 30) + '...' : eResources.resourceAuthor}</p>
                                <p>
                                  <FontAwesomeIcon icon={['fas', 'eye']} size="xl" style={{ fontSize: '10px' }} /> &nbsp;&nbsp;
                                  <span style={{ fontSize: '12px' }}>{eResources.totalViews} Views</span>
                                </p>
                              </div>
                            </div>
                          </>
                        );

                      })}
                    {
                      !loadingEResourceList &&
                      <span className='col-md-1 mt-5'>
                        <FontAwesomeIcon icon={['fas', 'arrow-circle-right']} size="xl" color='#7cabcc' style={{ fontSize: '22px', cursor: 'pointer' }} onClick={() => window.location.href = config.RootUrl + '/modules/library/#/eresources'} />
                      </span>
                    }
                  </div>
                </div>
              </div>
              <div className="col-md-12 pl-0 pr-0" style={{ marginTop: '1%' }}>
                <div className="row">
                  <div className="col-md-4 pl-0 pr-0">
                    <div class="count-rectangles d-flex marginTopForMobView">
                      <div class="side-retangle mt-3"></div>
                      <div className='col-md-11 pl-4 mt-3'>
                        <p className="smallHeadings">Number of Donor Count</p>
                        <p className='mt-3 d-flex justify-content-between'>
                          {loadingStatus ?
                            <div className="counts d-flex justify-content-center align-items-center">
                              0
                            </div>
                            :
                            <span className="counts">{donorCount}</span>
                          }
                          <span>
                            <FontAwesomeIcon icon={['fas', 'chevron-circle-right']} size="xl" color='#7cabcc' style={{ fontSize: '20px', cursor: 'pointer' }} onClick={() => window.location.href = config.RootUrl + '/modules/library/#/donorlist'} />
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="count-rectangles d-flex marginTopForMobView" style={{ marginTop: '2%' }}>
                      <div class="side-retangle mt-3"></div>
                      <div className='col-md-11 pl-4 mt-3'>
                        <p className="smallHeadings">Purchase Request Count</p>
                        <p className='mt-3 d-flex justify-content-between'>
                          {loadingStatus ?
                            <div className="counts d-flex justify-content-center align-items-center">
                              0
                            </div>
                            :
                            <span className="counts">{pRCount}</span>
                          }
                          <span>
                            <FontAwesomeIcon icon={['fas', 'chevron-circle-right']} size="xl" color='#7cabcc' style={{ fontSize: '20px', cursor: 'pointer' }} onClick={() => window.location.href = config.RootUrl + '/modules/library/#/purchaserequest'} />
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="count-rectangles d-flex marginTopForMobView" style={{ marginTop: '2%' }}>
                      <div class="side-retangle mt-3"></div>
                      <div className='col-md-11 pl-4 mt-3'>
                        <p className="smallHeadings">Resource Categories</p>
                        <p className='d-flex justify-content-between'>
                          {loadingStatus ?
                            <div className="counts mt-3 d-flex justify-content-center align-items-center">
                              0
                            </div>
                            :
                            <span className="counts mt-3">{categoryCount}</span>
                          }
                          <span>
                            <img style={{ height: "40px", minWidth: "25%", maxWidth: "100%", cursor: 'pointer' }} src={qrcode} onClick={() => window.location.href = config.RootUrl + '/modules/library/#/resourcecategory'} />
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* LIBRARY CARD */}
                  <div className="col-md-4 libraryCardMob">
                    <div class="libraryCard marginTopForMobView">
                      <div className='col-md-12 pt-3'>
                        <p style={{ fontSize: "18px", fontFamily: "Nunito", fontWeight: '600' }} >My Library Card</p>
                        <div className='d-flex flex-column align-items-center mt-5'>
                          <img style={{ height: "52px", minWidth: "17%", maxWidth: "100%", borderRadius: "50%" }} src={config.instructorInfo.UserDp || defaultUser} />
                          <p className="smallHeadings mt-3" style={{ fontSize: "18px", fontWeight: '600' }}>{config.instructorInfo.FirstName + '  ' + config.instructorInfo.LastName}</p>
                          <p className="smallHeadings mb-3" style={{ color: '#565656' }}>{config.instructorInfo.user_id}</p>
                          <Barcode
                            value={config.instructorInfo.user_id}
                            width={'1%'}
                            height={'50vh'}
                            displayValue={false}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 pl-0 pr-0">
                    <div class="requisition marginTopForMobView">
                      <div class="col-md-12 pt-3">
                        <p style={{ fontSize: "18px", fontFamily: "Nunito", fontWeight: '600' }}>Resource Requisition</p>

                        <div className="donut">
                          <Chart
                            options={options}
                            series={series}
                            type="donut"
                            width="100%"
                          />
                        </div>
                        <p className='smallHeadings d-flex flex-column align-items-center mt-2' style={{ fontWeight: '600' }}>Total Requisition Count : {requisitionCount}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-3" style={{ MaxWidth: "100% !important" }}>
                  <img className='stockVerificationImg' src={stock} alt="Stock Verification Image" onClick={() => window.location.href = config.RootUrl + '/modules/library/#/stockverification'} />
                </div>
              </div>
            </div>
            {/* OPAC LINK */}
            <div className="col-md-4 libraryCardMob">
              <div className="opac-rectangle pr-2 marginTopForMobView">
                <div class="col-md-12 d-flex">
                  <div className="col-md-9 mt-4">
                    <p style={{ fontWeight: 'bold' }}>OPAC</p>
                    <p className="headings mt-3 mb-3" style={{ color: '#555555' }}>An OPAC (Online Public Access Catalog) is an online bibliography of a library collection that is available to the public.</p>
                    <a onClick={() => { setShowInstituteWiseOPAC(true) }} className="headings ui-link-hover" style={{ fontWeight: 'bold', color: '#007bff', cursor: 'pointer' }}><u>Access Multiple OPAC</u></a>
                  </div>
                  <div className="col-md-3 mt-5 QRPadding">
                    <QRCode
                      value={opacLink}
                      size={75}
                    />
                  </div>
                </div>
              </div>

              {/* LATEST ISSUED OR RETURNED RESOURCES LIST */}
              <div className="issueReturn-rectangle marginTopForMobView">
                <div className='col-md-12 pt-3'>
                  <p className='pl-3 mb-3' style={{ fontSize: "18px", fontFamily: "Nunito", fontWeight: '600' }}>Latest Issue / Return Resources</p>
                  <div className='col-md-12 libraryCardMob pr-0'>
                    <div className='d-flex'>
                      <div className='col-md-4 pl-0'>
                        <div className='totalIssueRectangle'>
                          <div className='col-md-12 mt-2 d-flex'>
                            <div className='col-md-1 pl-0'>
                              <FontAwesomeIcon icon={['fas', 'book']} size="sm" color="#955BF3" />
                            </div>
                            <div className='col-md-11'>
                              <p className='fs' >Total Issued Resources</p>
                              {loadingStatus ?
                                <div style={{ fontSize: '14px' }}>
                                  0
                                </div>
                                :
                                <p style={{ fontSize: '14px' }}>{totalIssuedResourceCount}</p>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-4 pl-0'>
                        <div className='issueRectangle'>
                          <div className='col-md-12 mt-2 d-flex'>
                            <div className='col-md-1 pl-0'>
                              <FontAwesomeIcon icon={['fas', 'check-circle']} size="sm" color="#955BF3" />
                            </div>
                            <div className='col-md-11'>
                              <p className='fs' >Today’s Total Issued Resources</p>
                              {loadingIssueList ?
                                <div style={{ fontSize: '14px' }}>
                                  0
                                </div>
                                :
                                <p style={{ fontSize: '14px' }}>{issuedCount}</p>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-4 pr-0'>
                        <div className='returnRectangle'>
                          <div className='col-md-12 mt-2 d-flex'>
                            <div className='col-md-1 pl-0'>
                              <FontAwesomeIcon icon={['fas', 'undo-alt']} size="sm" color="#FAAC0A" />
                            </div>
                            <div className='col-md-11'>
                              <p className='fs'>
                                Today’s Total Returned Resources
                              </p>

                              {loadingIssueList ?
                                <div style={{ fontSize: '14px' }}>
                                  0
                                </div>
                                :
                                <p style={{ fontSize: '14px' }}>{returnedCount}</p>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='mt-3 col-md-12 issueReturnList marginTopForMobView'>
                      {loadingIssueList ?
                        <div className=" d-flex justify-content-center align-items-center">
                          <ButtonLoader />
                        </div>
                        :
                        Object.keys(issueReturnData).length > 0 &&
                        Object.keys(issueReturnData).reverse().map((items, index) => {
                          let resourceData = issueReturnData[items];

                          return (
                            <>
                              <div className=' mt-4 pl-0 d-flex'>
                                <div className='col-md-10 pl-0'>
                                  <p style={{ fontSize: "10px", color: '#807C7C', fontFamily: 'Nunito' }}>Issued To</p>
                                  <p className='smallHeadings'>{resourceData.user_name} <span className='smallHeadings' style={{ textTransform: 'capitalize' }}>({resourceData.user_role})</span> | <span className='smallHeadings' style={{ textTransform: 'capitalize' }}>{resourceData.userInstituteName}</span></p>
                                  <p style={{ fontSize: "10px", color: '#807C7C', fontFamily: 'Nunito' }}>Resource Details</p>
                                  <p className='smallHeadings'>{resourceData.title} | {resourceData.author} | {resourceData.resourseInstituteName}</p>
                                </div>
                                <div className='col-md-2 mt-3'>
                                  <span className={resourceData.status == 'issued' ? 'issuedBadge' : 'returnedBadge'} style={{ textTransform: 'capitalize' }}>{resourceData.status}</span>
                                </div>
                              </div>
                            </>
                          )
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >

      {showInstituteWiseOPAC && returnMultipleOpacLink()}
    </>
  )
}
